import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AppConfigServiceService {

  private appConfig: any;

  constructor(private http: HttpClient) { }

  loadAppConfig() {
    //return this.http.get('/webSite/assets/config.json') //Dela na .117
   //return this.http.get('assets/config.json') //localhost in bilumina.com/help/
   return this.http.get('assets/config.json')
   .toPromise()
    .then(data => {
      this.appConfig = data;
    });

  }

  // This is an example property ... you can make it however you want.
  get apiBaseUrl() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }

    return this.appConfig.API_LOGIN;
  }

  get api() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }

    return this.appConfig.API;
  }

  get mobile() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }

    return this.appConfig.MOBILE;
  }

  get apiWeb() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }

    return this.appConfig.API_WEB;
  }

  get apiMonitor() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }

    return this.appConfig.API_MONITOR;
  }

  get apiFileUpload() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }

    return this.appConfig.API_FILE_UPLOAD;
  }

  get apiAssets() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }

    return this.appConfig.ASSETS_CONSTANT;
  }

  get apiSale() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }

    return this.appConfig.API_SALE;
  }

  get configShowValidation() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }

    return this.appConfig.showValidation;
  }

  get configWhichLogin() {
    if (!this.appConfig) {
      throw Error('Config file not loaded!');
    }
    return this.appConfig.whichLogin;
  }
}
